angular
	.module 'App.Component'
	.component 'productPricing',
	{
		templateUrl: '@component/product-pricing/product-pricing.view.html'
		controller: 'ProductPricingComponent'
		controllerAs: 'pricing'
		bindings:
			# Can be either product or product variant
			entity: '<'
			priceRegions: '<'
			vatRates: '<'
			# Disable all inputs. default: false
			disabled: '<?'
			# Show variable price selection. default: false
			variablePriceEnabled: '<?'
			# Change how Product Data is handled
			# Possible values: `single`, `multi` (default: `multi`)
			# - single: always keep one
			# - multi: allow to select multiple Product Data
			mode: '<?'
			# default: true
			costPriceRequired: '<?'
			# default: true
			retailPriceRequired: '<?'
			# Will be passed currently selected price region and changed product data (if available)
			# E.g. onChange(priceRegionId, productData)
			onChangeCallback: '&?onChange'
	}

class ProductPricingComponent extends AbstractController
	@register()
	@inject 'BACKEND_PRODUCT_DATA_ENTITY_TYPE',
		'Guid'
		'ConfigurationService'

	initialize: ->
		@isMultiMode = !@mode? || @mode == 'multi'
		@disabled ?= false
		@variablePriceEnabled ?= true
		@costPriceRequired ?= true
		@retailPriceRequired ?= true
		@isVatRateEnabled = @ConfigurationService.isEnabled 'Shared.Setting.VatRate.Enabled'

		if @isMultiMode
			@initializeMultiMode()
		else
			@initializeSingleMode()

	initializeMultiMode: ->
		@groupPriceRegions()

		existingRegionId = @entity.product_data[0]?.price_region_id

		if existingRegionId?
			doesPriceRegionHasPrice = _.find @priceRegionsWithPrice, {id: existingRegionId}

			if doesPriceRegionHasPrice
				@currentPriceRegionWithPriceId = existingRegionId
				@currentPriceRegionWithoutPriceId = null
				@selectedPriceRegionId = existingRegionId
			else if _.find @priceRegionsWithoutPrice, {id: existingRegionId}
				@currentPriceRegionWithPriceId = null
				@currentPriceRegionWithoutPriceId = existingRegionId
				@selectedPriceRegionId = existingRegionId
			else
				@setInitialPriceRegion()
		else
			@setInitialPriceRegion()

		@hasProductData = _.find(@entity.product_data, {price_region_id: @selectedPriceRegionId})?
		@onChange()

	initializeSingleMode: ->
		if @entity.product_data.length
			@selectedPriceRegionId = @entity.product_data[0].price_region_id
		else
			@selectedPriceRegionId = @priceRegions[0]?.id
		@hasProductData = true

	groupPriceRegions: ->
		if !@isMultiMode
			return

		groupedProductData = _.groupBy @entity.product_data, (item) -> item.price_region_id
		@priceRegionsWithPrice = []
		@priceRegionsWithoutPrice = []

		for priceRegion in @priceRegions
			if _.isEmpty groupedProductData[priceRegion.id]
				@priceRegionsWithoutPrice.push priceRegion
			else
				@priceRegionsWithPrice.push priceRegion

	setInitialPriceRegion: ->
		if !_.isEmpty @priceRegionsWithPrice
			@currentPriceRegionWithPriceId = @priceRegionsWithPrice[0].id
			@currentPriceRegionWithoutPriceId = null
			@selectedPriceRegionId = @currentPriceRegionWithPriceId
		else
			@currentPriceRegionWithPriceId = null
			@currentPriceRegionWithoutPriceId = @priceRegionsWithoutPrice[0]?.id
			@selectedPriceRegionId = @currentPriceRegionWithoutPriceId

	onPriceRegionChange: (isWithPrice) ->
		if @isMultiMode
			if isWithPrice
				@selectedPriceRegionId = @currentPriceRegionWithPriceId
			else
				@selectedPriceRegionId = @currentPriceRegionWithoutPriceId

			@hasProductData = _.find(@entity.product_data, {price_region_id: @selectedPriceRegionId})?
			@switchPriceRegionGroup()
			@onChange()

			return

		if @entity.product_data.length
			_.first(@entity.product_data).price_region_id = @selectedPriceRegionId

		@onChange()

	switchPriceRegionGroup: ->
		if !@isMultiMode
			return

		doesSelectedProductDataOnEntityExist = _.find(@entity.product_data, {price_region_id: @selectedPriceRegionId})?

		if doesSelectedProductDataOnEntityExist
			@currentPriceRegionWithPriceId = @selectedPriceRegionId
			@currentPriceRegionWithoutPriceId = null
		else
			@currentPriceRegionWithoutPriceId = @selectedPriceRegionId
			@currentPriceRegionWithPriceId = null

	onPriceChange: (productData) ->
		@onChange(productData)

	onChange: (productData = null) ->
		if !@onChangeCallback?
			return

		if !productData? && !@isMultiMode
			productData = _.first(@entity.product_data)

		@onChangeCallback({priceRegionId: @selectedPriceRegionId, productData: productData})

	# Adds new product data. Also ensures there is initial Product Data set
	addProductData: ->
		@entity.product_data ?= []
		@hasProductData = true

		if @isMultiMode || _.isEmpty(@entity.product_data)
			newProductData =
				id: @Guid.generate()
				entity_type: @BACKEND_PRODUCT_DATA_ENTITY_TYPE.PRODUCT_DATA
				price_region_id: @selectedPriceRegionId
				vat_rate_id: null
				variable_price: '0'
				cost_price: 0
				retail_price: 0
			@entity.product_data.push(newProductData)

			@groupPriceRegions()
			@switchPriceRegionGroup()
			@onChange(newProductData)
			@$scope.pricingForm.$setDirty()

	removeProductData: (productData) ->
		@hasProductData = false
		@entity.product_data = _.reject(@entity.product_data, {id: productData.id})

		@groupPriceRegions()
		@switchPriceRegionGroup()
		@onChange(productData)
		@$scope.pricingForm.$setDirty()
